import { forwardRef } from 'react';
import { useComponentLibrary } from '../../FormRenderCtx';
import AutoCompleteMaterial from './AutoCompleteMaterial';
import AutoCompleteAnt from './AutoCompleteAnt';

const AutoCompleteUI = forwardRef(function AutoCompleteUI(props, ref) {
  const componentLibrary = useComponentLibrary();

  if (componentLibrary === 'material-ui') {
    return <AutoCompleteMaterial {...props} ref={ref} />;
  }

  return <AutoCompleteAnt {...props} ref={ref} />;
});

export default AutoCompleteUI;
